<template>
  <div>
    <p>
      The sum of all environmental losses
      <katex-element expression="L_{env}" /> is given (in
      <katex-element expression="dB" />) by:
    </p>
    <p>
      <katex-element
        expression="L_{env} =  L_{rain} + L_{pol} + L_{vis} + L_{ion} + L_{atm} + L_{FSPL}"
      />
    </p>
    <p>where:</p>
    <ul>
      <li>
        <katex-element expression="L_{rain}" /> is the rain loss (<katex-element
          expression="dB"
        />);
      </li>
      <li>
        <katex-element expression="L_{pol}" /> is the polarization loss
        (<katex-element expression="dB" />);
      </li>
      <li>
        <katex-element
          expression="L_{vis} = \infty \; \mathrm{if} \; elevation < 0 \mathrm{, otherwise} \; 0"
        />
        is the visibility loss obstruction (<katex-element expression="dB" />);
      </li>
      <li>
        <katex-element expression="L_{ion}" /> is the ionospheric loss
        (<katex-element expression="dB" />);
      </li>
      <li>
        <katex-element expression="L_{atm}" /> is the atmospheric loss
        (<katex-element expression="dB" />);
      </li>
      <li>
        <katex-element expression="L_{FSPL}" /> is the free-space path loss
        (<katex-element expression="dB" />);
      </li>
    </ul>
    <br />
  </div>
</template>

<script>
export default {
  name: 'tooltipEquationEnvironmentalLosses'
}
</script>
